(() => {
  if (window.loadingComboInitialized) return;
  window.loadingComboInitialized = true;

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  const revealObserver =
    'IntersectionObserver' in window
      ? new IntersectionObserver(
          (entries, observer) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;
              entry.target.classList.add('is-visible');
              observer.unobserve(entry.target);
            });
          },
          { rootMargin: '0px 0px -8% 0px', threshold: 0.12 }
        )
      : null;

  const initializeReveal = (scope = document) => {
    const elements = scope.querySelectorAll('.loading-combo [data-combo-reveal]:not([data-combo-reveal-initialized])');

    elements.forEach((element) => {
      element.dataset.comboRevealInitialized = 'true';

      if (reducedMotion.matches || !revealObserver) {
        element.classList.add('is-visible');
        return;
      }

      element.classList.add('loading-combo-reveal-ready');
      revealObserver.observe(element);
    });
  };

  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    const trigger = event.target.closest('[data-combo-scroll]');
    if (!trigger) return;

    const href = trigger.getAttribute('href');
    if (!href || !href.startsWith('#')) return;

    const target = document.querySelector(href);
    if (!target) return;

    event.preventDefault();
    target.scrollIntoView({ behavior: reducedMotion.matches ? 'auto' : 'smooth', block: 'start' });

    if (target.hasAttribute('tabindex')) {
      target.focus({ preventScroll: true });
    }
  });

  document.addEventListener('shopify:section:load', (event) => initializeReveal(event.target));

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeReveal(), { once: true });
  } else {
    initializeReveal();
  }
})();
